import type { Theme } from '@mui/material';

export const uakdoControlSectionStyles = {
  fieldsStack: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  }),
  topRow: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      md: 'repeat(2, minmax(0, 1fr))',
    },
    gap: theme.spacing(1.5),
    alignItems: 'start',
  }),
  fullWidthField: {
    width: '100%',
  },
} as const;
